import React, { useEffect, useState } from 'react';
import { useData } from '../context/DataContext';
import { Activity, X, Database, ArrowUpCircle, ArrowDownCircle, Info, RotateCcw } from 'lucide-react';

const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';

export default function StatsDisplay() {
  const { stats, resetStats } = useData();
  const [show, setShow] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${API_URL}/settings/logos`);
        const data = await response.json();
        setShow(data.showStats !== false);
      } catch (e) { console.error(e); }
    };
    fetchSettings();
  }, []);

  if (!show) return null;

  return (
    <>
      <div 
        onClick={() => setIsOpen(true)}
        className="fixed bottom-4 right-4 bg-gray-900/90 dark:bg-black/90 text-white p-3 rounded-lg shadow-lg z-[60] text-xs font-mono flex items-center gap-3 backdrop-blur-sm border border-gray-700 cursor-pointer hover:bg-gray-800 transition-all hover:scale-105 active:scale-95"
        title="Detaylı Rapor İçin Tıklayın"
      >
        <Activity size={16} className="text-green-400 animate-pulse" />
        <div className="flex gap-4">
          <div>Okuma: <span className="text-green-400 font-bold">{stats.reads}</span></div>
          <div>Yazma: <span className="text-orange-400 font-bold">{stats.writes}</span></div>
        </div>
      </div>

      {isOpen && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[70] flex items-center justify-center p-4 animate-in fade-in duration-200" onClick={() => setIsOpen(false)}>
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full overflow-hidden border border-gray-200 dark:border-gray-700 animate-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()}>
            <div className="p-4 border-b border-gray-100 dark:border-gray-700 flex justify-between items-center bg-gray-50 dark:bg-gray-900/50">
              <h3 className="font-bold text-gray-800 dark:text-white flex items-center gap-2">
                <Database size={18} className="text-blue-600" />
                Veritabanı Kullanım Raporu
              </h3>
              <button 
                onClick={() => setIsOpen(false)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                <X size={20} />
              </button>
            </div>
            
            <div className="p-6 space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-green-50 dark:bg-green-900/20 p-4 rounded-xl border border-green-100 dark:border-green-900/30 flex flex-col items-center text-center">
                  <div className="p-3 bg-green-100 dark:bg-green-900/50 rounded-full mb-3 text-green-600 dark:text-green-400">
                    <ArrowDownCircle size={24} />
                  </div>
                  <span className="text-sm text-gray-600 dark:text-gray-400 font-medium uppercase tracking-wider">Okuma</span>
                  <span className="text-3xl font-bold text-green-600 dark:text-green-400 mt-1">{stats.reads}</span>
                  <span className="text-[10px] text-gray-500 dark:text-gray-500 mt-1">Belge Getirme</span>
                </div>

                <div className="bg-orange-50 dark:bg-orange-900/20 p-4 rounded-xl border border-orange-100 dark:border-orange-900/30 flex flex-col items-center text-center">
                  <div className="p-3 bg-orange-100 dark:bg-orange-900/50 rounded-full mb-3 text-orange-600 dark:text-orange-400">
                    <ArrowUpCircle size={24} />
                  </div>
                  <span className="text-sm text-gray-600 dark:text-gray-400 font-medium uppercase tracking-wider">Yazma</span>
                  <span className="text-3xl font-bold text-orange-600 dark:text-orange-400 mt-1">{stats.writes}</span>
                  <span className="text-[10px] text-gray-500 dark:text-gray-500 mt-1">Ekle/Sil/Güncelle</span>
                </div>
              </div>

              <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg flex gap-3 items-start text-sm text-blue-800 dark:text-blue-300 border border-blue-100 dark:border-blue-900/30">
                <Info size={18} className="shrink-0 mt-0.5" />
                <p className="leading-relaxed">
                  Bu istatistikler, mevcut oturumunuz boyunca veritabanı ile yapılan anlık etkileşimleri gösterir. Sayfa yenilendiğinde bu sayaçlar sıfırlanır.
                </p>
              </div>
            </div>
            
            <div className="p-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 flex justify-between items-center">
              <button 
                onClick={resetStats}
                className="flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors text-sm font-medium"
              >
                <RotateCcw size={16} />
                Sıfırla
              </button>
              <button 
                onClick={() => setIsOpen(false)}
                className="px-5 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors text-sm font-medium shadow-sm"
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
